import { editPublicCertificateProps } from 'types/Common'

export const emailRex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

// VERA-1095: `passwordRex` was DELETED here along with its only consumer, the
// never-imported `components/Fields/Password.tsx`. It carried a `/g` flag,
// which makes `RegExp.prototype.test` STATEFUL — `lastIndex` advances on a
// match and the next call resumes from there, so the same string alternates
// pass/fail across calls. React Hook Form's `pattern` rule calls `test` on
// every keystroke, so had that component ever been rendered the field would
// have accepted a password and then rejected the identical text one character
// later. The platform's own copy of this regex was removed for a different
// reason (it disagreed with the policy it claimed to enforce); see
// `apps/platform/src/constants/regex.ts`. If a composition rule is ever needed
// in this app, write it without `/g`.

export const fieldCannotBeEmpty = 'This field is required'
export const maxLengthName = 'The name is too long. Max length is 120 characters.'
export const maxLength = 'Max length is 120 characters.'
export const maxLengthTextarea = 'Max length is 500 characters.'
export const emailIsNotCorrect = 'Please enter a enabled email address.'
export const googleMapKey = 'AIzaSyDU4cqEVWktM0AYLFrC92-45G0LgwY78Lw'
export const searchDebounceDelay = 400
// `passwordValidationMinLen` / `passwordValidationMaxLen` / `passwordValidationText`
// went with `passwordRex` above — the deleted password field was their only
// consumer, and a message describing a rule nothing enforces is worse than no
// message.
export const statusesAll = [
  { label: 'active', value: 'active' },
  { label: 'transfer in', value: 'in_transfer' },
  { label: 'transfer out', value: 'out_transfer' },
  { label: 'transfer out', value: 'waiting_accept' },
  { label: 'transfer out', value: 'transfer_initiated' },
  { label: 'transfer out', value: 'transfer_waiting_confirmation' },
  { label: 'cancel request', value: 'cancel_request' },
  { label: 'lost', value: 'lost' },
  { label: 'stolen', value: 'stolen' },
  { label: 'transferred', value: 'transferred' },
  { label: 'transfer canceled', value: 'transfer_canceled' },
  { label: 'returned', value: 'returned' },
]

export const menuItemsActive = [
  'Transfer Ownership',
  'Edit Public Certificate',
  'Copy Link',
  // 'Share scan history',
  // 'Report Missing',
]
export const menuItemsTransferIn = ['Claim ownership', 'Cancel transfer']
export const menuItemsTransferOut = ['Request cancel', 'Edit public certificate', 'Copy Link', 'Share scan history']
export const menuItemsLost = ['Change to Stolen', 'Reclaim ownership', 'Share scan history']
export const menuItemsStolen = ['Change to Lost', 'Reclaim ownership', 'Share scan history']

export const genderOptions = [
  { value: 'male', title: 'Male' },
  { value: 'female', title: 'Female' },
  { value: 'transgender', title: 'Transgender' },
  { value: 'non_binary', title: 'Non-binary' },
]

export const editPublicCertificate: editPublicCertificateProps[] = [
  {
    name: 'show_provenance',
    label: {
      title: 'Show provenance',
      description: 'All previous ownership history.',
    },
  },
  {
    name: 'show_scan_history',
    label: {
      title: 'Show scan history',
      description: 'The location and identity of every scan of this item since you’ve been the owner.',
    },
  },
]
